import { ReactNode } from 'react'
import styled from 'styled-components'
const n = (num: number, precision = 1) =>
  (+num.toFixed(precision)).toLocaleString('de-CH')

export const SingleFactWrapper = ({ children }: { children?: ReactNode }) => {
  return <SingleFactWrapperRoot>{children && children}</SingleFactWrapperRoot>
}

const SingleFactWrapperRoot = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  line-height: 1.4em;
`
export const SingleFact = ({
  value,
  label,
  icon,
}: {
  value?: string | number
  label?: string
  icon?: string
}) => {
  return (
    <SingleFactRoot>
      {icon && <img src={icon} />}
      {value !== undefined && <Value>{n(+value)}</Value>}
      {label && <Label>{label}</Label>}
    </SingleFactRoot>
  )
}

const SingleFactRoot = styled.div`
  flex: 0 0 50%;
  margin-bottom: 30px;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  img {
   
    max-width: 120px;
  }
`
const Value = styled.div`
  font-weight: 700;
  width: 100%;
  text-align: center;
  font-size: 22px;
  margin-bottom: 5px;
`
const Label = styled.div`
  width: 100%;
  text-align: center;
  font-size: 15px;
  line-height: 1.2em;
`
